export { deletionRequestsEn } from './en';
export { deletionRequestsSk } from './sk';
export { deletionRequestsCz } from './cz';

// Helper function to get deletion request translations by language
import { deletionRequestsEn } from './en';
import { deletionRequestsSk } from './sk';
import { deletionRequestsCz } from './cz';

export function getDeletionRequests(lang: string) {
  switch (lang.toLowerCase()) {
    case 'sk':
      return deletionRequestsSk;
    case 'cz':
      return deletionRequestsCz;
    case 'en':
    default:
      return deletionRequestsEn;
  }
}